export const PROVER_SITE = {
  tenantId: 'prover',
  name: 'Prover Clínica Oftalmológica',
  address: 'Clínica Oftalmológica Pro-Ver S.A.\nP94P+MF7, Eligio Ayala, Asunción 001225, Paraguay',
  location: {
    lat: -25.2343066,
    lng: -57.5399591,
    mapUrl: 'https://www.google.com/maps?q=ProVer+Cl%C3%ADnica+Oftalmol%C3%B3gica%2C+Eligio+Ayala%2C+Asunci%C3%B3n%2C+Paraguay&z=16&output=embed',
    directionsUrl: 'https://www.waze.com/es-419/live-map/directions/py/asuncion/asuncion/clinica-oftalmologica-pro-ver-s.a.?to=place.ChIJExym0lenXZQRA_FuR43jWII'
  },
  phone: import.meta.env.VITE_PROVER_WHATSAPP || '595982465279',
  whatsapp: import.meta.env.VITE_PROVER_WHATSAPP || '595982465279',
  languages: ['es', 'pt', 'en', 'gn'],
  routes: {
    booking: '/agenda',
    patientPortal: '/portal',
    management: '/gestion'
  },
  assets: {
    logo: '/tenants/prover/prover-logo-official.jpg',
    isotipo: '/tenants/prover/prover-isotipo-official.jpg',
    surgery: '/tenants/prover/cirugia.png',
    or: '/tenants/prover/procedimiento-quirofano.png'
  },
  gallery: [
    { src: '/tenants/prover/cirugia.png', alt: 'Cirugía oftalmológica con microscopio quirúrgico' },
    { src: '/tenants/prover/consulta-dante.jpg', alt: 'Consulta oftalmológica pediátrica' },
    { src: '/tenants/prover/cirugia-galeria-1.jpg', alt: 'Cirugía oftalmológica en quirófano' },
    { src: '/tenants/prover/cirugia-galeria-2.jpg', alt: 'Procedimiento oftalmológico especializado' }
  ],
  doctorsFallback: [
    {
      id: 'miriam',
      name: 'Dra. Miriam Concepción Ayala vda. de Contreras',
      specialty: 'Cirujana · Retina Clínica',
      regProf: 'Reg. Prof. N° 3353',
      photo_url: '/tenants/prover/dra-miriam-ayala.jpg'
    },
    {
      id: 'ricardo',
      name: 'Dr. Ricardo Daniel Contreras Ayala',
      specialty: 'Cirujano · Oftalmología General y Quirúrgica',
      regProf: 'Reg. Prof. N° 10760',
      photo_url: '/tenants/prover/dr-ricardo-contreras.png'
    },
    {
      id: 'veronica',
      name: 'Dra. Verónica Concepción Contreras Ayala',
      specialty: 'Cirujana · Oftalmología Pediátrica · Estrabismo en Niños y Adultos',
      regProf: 'Reg. Prof. N° 9083',
      photo_url: '/tenants/prover/dra-veronica-contreras.jpg'
    }
  ]
}
